'use client'
import { useEffect } from 'react'

declare global {
  interface Window {
    initAlficdl?: (forceReload: boolean) => void
    alficdlInitialized?: boolean
  }
}

export default function DatenschutzScript() {
  useEffect(() => {
    if (window.initAlficdl) {
      window.initAlficdl(true)
      return
    }

    const script = document.createElement('script')
    script.src = 'https://app.alfright.eu/hosted/dps/alfidcl.js'
    script.setAttribute('alfidcl-script', '')
    script.async = true

    script.onload = () => {

      if (window.initAlficdl) {
        window.initAlficdl(true)
      }
    }

    document.body.appendChild(script)

  }, [])

  return null
}